/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Input, Select, DatePicker, Button, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import PhoneInput, { parsePhoneNumber, PhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { generateTimeSlots } from '../../constants';
import { useUsers } from '../../hooks/useUser';
import { useAgenda } from '../../hooks/useAgenda';
import { useForwardMeeting, useRejectMeeting } from '../../hooks/useMeetings';
import { useAppStore } from '../../store/appStore';

const timeSlots = generateTimeSlots();

export interface MeetingRequestData {
  id: number;
  plantId: string;
  organisation: string;
  title: string;
  preferredDate: string;
  preferredTime: string;
  additionalNotes: string;
  requestStatus: string;
  requestorId: number;
  agendaId?: number;
  subAgendaId?: number;
  requestor: {
    id: number;
    requesterName: string;
    requesterEmail: string;
    requesterPhone: string;
    requesterDesignation: string;
  };
  plant: {
    id: string;
    name: string;
    location: string;
    description: string;
  };
  meetingRequestAttendees: Array<{
    id: number;
    attendee: {
      id: number;
      name: string;
      email: string;
      designation: string;
    };
  }>;
  meetingRequestExternalUsers: Array<{
    id: number;
    name: string;
    email: string;
    designation: string;
  }>;
}

interface FormValues {
  organisation: string;
  title: string;
  meetingDate: dayjs.Dayjs;
  meetingTime: string;
  additionalNotes: string;
  requesterName: string;
  requesterEmail: string;
  requesterPhone: string;
  setDuration: number;
  agendaId?: number;
  subAgendaId?: number;
  assignedUserIds: string[];
  requesterDesignation: string;
  presenter: string[];
  admin: string[];
  attendees: Array<{
    fullName: string;
    email: string;
    designation: string;
  }>;
  externalUsers: Array<{
    fullName: string;
    email: string;
    position: string;
  }>;
  designation: any;
}

interface EditMeetingModalProps {
  meetingData: MeetingRequestData;
  closeStatusModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ForwardMeeting: React.FC<EditMeetingModalProps> = ({ closeStatusModal, meetingData }) => {
  const [form] = useForm<FormValues>();
  console.log('meeting data is coming..++++++', meetingData);

  const { mutate: rejectMeeting, isPending: isRejectPending } = useRejectMeeting();
  const { mutate: forwardMeetingMutate, isPending: isForwarding } = useForwardMeeting();

  const profile = useAppStore((state) => state.profile);
  const userId = profile.user.id;
  const handleCancel = () => {
    closeStatusModal(false);
    rejectMeeting(meetingData.id, {
      onSuccess: () => {
        // Reset form and state only after successful rejection
        form.resetFields();
        setPhone(undefined);
        message.success('Meeting rejected successfully');
      },
      onError: (error: Error) => {
        message.error(`Failed to reject meeting: ${error.message}`);
      },
    });
  };

  const [phone, setPhone] = useState<PhoneNumber | undefined>();

  useEffect(() => {
    if (meetingData) {
      // Combine attendees from both sources
      const allAttendees = [
        ...meetingData.meetingRequestAttendees.map((item) => ({
          id: item.attendee.id,
          fullName: item.attendee.name,
          email: item.attendee.email,
          department: item.attendee.designation,
        })),
        ...meetingData.meetingRequestExternalUsers.map((user) => ({
          fullName: user.name,
          email: user.email,
          position: user.designation,
        })),
      ];

      // Set form values
      form.setFieldsValue({
        organisation: meetingData.organisation,
        title: meetingData.title,
        meetingDate: dayjs(meetingData.preferredDate),
        meetingTime: meetingData.preferredTime,
        additionalNotes: meetingData.additionalNotes,
        agendaId: meetingData.agendaId,
        subAgendaId: meetingData.subAgendaId,
        requesterName: meetingData.requestor.requesterName,
        requesterEmail: meetingData.requestor.requesterEmail,
        requesterDesignation: meetingData.requestor.requesterDesignation,
        attendees: allAttendees,
        requesterPhone: meetingData.requestor.requesterPhone,
      });

      // Parse and set phone number
      const parsedPhone = parsePhoneNumber(meetingData.requestor.requesterPhone || '');
      setPhone(parsedPhone);
    }
  }, [meetingData, form]);

  // const handleSubmit = async (values: FormValues) => {
  //   forwardMeetingMutate(
  //     {
  //       sendEmail: true,
  //       id: meetingData.id,
  //       notes: values.additionalNotes || '',
  //     },
  //     {
  //       onSuccess: () => {
  //         message.success('Meeting forwarded successfully');
  //         closeStatusModal(false);
  //       },
  //       onError: (error: Error) => {
  //         message.error(`Failed to forward meeting: ${error.message}`);
  //       },
  //     }
  //   );
  // };

  const handleSubmit = async (values: FormValues) => {
    const payload = {
      plantName: "kosamba",
      location: "kosamba, Gujarat",

      organisation: values.organisation,
      title: values.title,

      meetingDate: values.meetingDate.format("YYYY-MM-DD"),
      meetingTime: values.meetingTime,

      agendaId: values.agendaId,
      subAgendaId: values.subAgendaId,

      createdBy: userId,
      setDuration: 60,

      requestorName: values.requesterName,
      requestorEmail: values.requesterEmail,
      phoneNumber: values.requesterPhone,

      attendees: values.attendees?.map((a: any) => ({
        id: a.id || 0,
        fullName: a.fullName,
        email: a.email,
        department: a.department,
      })) || [],

      externalUsers: values.externalUsers?.map((u: any) => ({
        fullName: u.fullName,
        email: u.email,
        department: u.department,
      })) || [],

      notes: values.additionalNotes,
      sendEmail: true
    };

    console.log({
      id: meetingData.id,
      payload,
    }, "hello1");

    forwardMeetingMutate(
      {
        id: meetingData.id,
        payload,
      },
      {
        onSuccess: () => {
          message.success("Meeting forwarded successfully");
          closeStatusModal(false);
        },
        onError: (error: Error) => {
          message.error(`Failed to forward meeting: ${error.message}`);
        },
      }
    );
  };





  const { data: agenda } = useAgenda();
  const selectedAgendaId = Form.useWatch('agendaId', form);
  const subAgendaOptions =
    (agenda || []).find((a: any) => a.agendaId === selectedAgendaId)?.subAgendas || [];
  const { data: users } = useUsers();
  console.log(agenda, 'agendas', users);

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit} className="mt-4">
      {/* Plant Information (Read-only) */}
      <div className="bg-gray-50 !p-4 rounded-lg !mb-4">
        <h3 className="text-lg font-semibold mb-2">Plant Information</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Plant Name</label>
            {/* <div className="mt-1 text-sm text-gray-900">{meetingData?.plant?.name}</div> */}
            <div className="mt-1 text-sm text-gray-900">kosamba</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Location</label>
            {/* <div className="mt-1 text-sm text-gray-900">{meetingData?.plant?.location}</div> */}
            <div className="mt-1 text-sm text-gray-900">kosamba, Gujarat</div>
          </div>
        </div>
      </div>

      {/* Meeting Information */}
      <div className="grid grid-cols-2 gap-4">

        <Form.Item
          label="Organisation"
          name="organisation"
          rules={[{ required: true, message: 'Please enter organisation' }]}
        >
          <Input placeholder="Organisation" />
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Please enter title' }]}
        >
          <Input placeholder="Title" />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* <Form.Item
          label="Date"
          name="meetingDate"
          rules={[{ required: true, message: 'Please select a date' }]}
        >
          <DatePicker className="w-full"  />
        </Form.Item> */}

        <Form.Item
          label="Date"
          name="meetingDate"
          rules={[{ required: true, message: 'Please select a date' }]}
        >
          <DatePicker
            className="w-full"
            format="DD-MM-YYYY"
          />
        </Form.Item>


        <Form.Item
          label="Time"
          name="meetingTime"
          rules={[{ required: true, message: 'Please select time' }]}
        >
          <Select placeholder="Select time" >
            {timeSlots.map((time) => (
              <Select.Option key={time.value} value={time.value}>
                {time.key}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          label="Agenda"
          name="agendaId"
          rules={[{ required: true, message: 'Please select an agenda' }]}
        >
          <Select
            placeholder="Select agenda"
            onChange={() => {
              form.setFieldsValue({ subAgendaId: undefined });
            }}
          >
            {(agenda || []).map((ag: any) => (
              <Select.Option key={ag.agendaId} value={ag.agendaId}>
                {ag.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Sub Agenda"
          name="subAgendaId"
          rules={[{ required: false, message: 'Please select a sub agenda' }]}
        >
          <Select placeholder="Select sub agenda" disabled={!selectedAgendaId}>
            {subAgendaOptions.map((s: any) => (
              <Select.Option key={s.subAgendaId} value={s.subAgendaId}>
                {s.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      {/* <Form.Item
        label="Duration"
        name="setDuration"
        rules={[{ required: true, message: 'Please select duration' }]}
        className="mb-2"
      >
        <Select placeholder="Select duration">
          {durationOptions.map((opt) => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Additional Notes" name="additionalNotes">
        <Input.TextArea rows={3} placeholder="Additional notes (optional)" />
      </Form.Item> */}

      {/* Requestor Information */}
      <div className="border-t !pt-4 !mt-4">
        <h3 className="text-lg font-semibold mb-4">Requestor Information</h3>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Name"
            name="requesterName"
            rules={[{ required: true, message: 'Please enter name' }]}
          >
            <Input placeholder="Name" disabled />
          </Form.Item>

          <Form.Item
            label="Email"
            name="requesterEmail"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Invalid email' },
            ]}
          >
            <Input placeholder="Email" disabled />
          </Form.Item>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Phone Number"
            name="requesterPhone"
            rules={[{ required: true, message: 'Please enter phone number' }]}
          >
            <PhoneInput
              international
              defaultCountry={phone?.country || 'IN'}
              value={phone?.number || ''}
              onChange={(val) => {
                const parsed = parsePhoneNumber(val || '');
                setPhone(parsed);
                form.setFieldsValue({ requesterPhone: val });
              }}
              placeholder="Enter phone number"
              className="custom-phone-input cursor-not-allowed bg-[#f5f4f4]"
              disabled
            />
          </Form.Item>

          {/* <Form.Item
            label="Designation"
            name="requesterDesignation"
            rules={[{ required: false, message: 'Please enter designation' }]}
          >
            <Input placeholder="Designation" disabled />
          </Form.Item> */}
        </div>
      </div>

      {/* Attendees */}
      {/* <div className="border-t !pt-4 !mt-4">
        {(() => {
          // Get all non-empty attendees from the form
          const attendees = form.getFieldValue('attendees') || [];
          // Filter out empty fields (only count attendees with at least a name or email or department)
          const validAttendees = Array.isArray(attendees)
            ? attendees.filter(
                (att) =>
                  (att &&
                    (att.fullName?.toString().trim() ||
                      att.email?.toString().trim() ||
                      att.department?.toString().trim()))
              )
            : [];

          return (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">
                  Requested Attendees{' '}
                  <span className="text-base text-gray-500">
                    ({validAttendees.length})
                  </span>
                </h3>
              </div>
              {validAttendees.length === 0 ? (
                <div className="text-gray-500 italic">No attendees</div>
              ) : (
                validAttendees.map((att, idx) => (
                  <div key={idx} className="grid grid-cols-4 gap-4 items-start">
                    <Form.Item>
                      <Input value={att.fullName} placeholder="Name"  />
                    </Form.Item>
                    <Form.Item>
                      <Input value={att.email} placeholder="Email"  />
                    </Form.Item>
                    <Form.Item>
                      <Input value={att.department} placeholder="Designation" />
                    </Form.Item>
                  </div>
                ))
              )}
            </div>
  

          );
        })()}
      </div> */}

      <div className="border-t !pt-4 !mt-4">
        <Form.List name="attendees">
          {(fields, { add, remove }) => (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Requested Attendees</h3>
                <Button type="dashed" onClick={() => add()}>
                  + Add Attendee
                </Button>
              </div>

              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="grid grid-cols-4 gap-4 items-start">

                  {/* ✅ Hidden ID field */}
                  <Form.Item
                    {...restField}
                    name={[name, 'id']}
                    hidden
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'fullName']}
                    rules={[{ required: true, message: 'Enter name' }]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'email']}
                    rules={[
                      { required: true, message: 'Enter email' },
                      { type: 'email', message: 'Invalid email' },
                    ]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'department']}
                    rules={[{ required: false, message: 'Enter designation' }]}
                  >
                    <Input placeholder="Designation" />
                  </Form.Item>

                  <Button type="link" danger onClick={() => remove(name)} className="mt-1">
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          )}
        </Form.List>
      </div>

      {/* Form Actions */}
      <div className="flex justify-end gap-2 !mt-6 !pt-4 border-t">
        <Button onClick={handleCancel} disabled={isRejectPending}>
          Reject
        </Button>
        <Button type="primary" htmlType="submit" loading={isForwarding}>
          Schedule
        </Button>
      </div>
    </Form>
  );
};

export default ForwardMeeting;
